import axios from 'axios';

import { store } from '../reducers/store';
import { getApiBaseUrl } from '../utils/environment';
import { LOGIN_SUCCESS, LOGOUT } from '../actions/auth';
import { showAlert } from '../actions/radminUploads';

const getBaseURL = () => getApiBaseUrl();

axios.defaults.withCredentials = true
axios.interceptors.request.use((config) => {

    const accessToken = store.getState().auth.accessToken;

    if (accessToken) {
          config.headers.Authorization = `Token ${accessToken}`;
    }

    return config;
});


let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => {
    error ? p.reject(error) : p.resolve(token);
  });
  failedQueue = [];
};

axios.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const originalRequest = error.config;

    const isRefreshRequest =
    originalRequest.url?.includes('/auth/token/refresh/');

    if (status === 401 && error.response?.data?.code === 'password_expired') {
      return Promise.reject(error);
    }

    if (status === 401 && isRefreshRequest) {
      store.dispatch({ type: LOGOUT });
      window.location = '/login';
      return Promise.reject(error);
    }

    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const { refreshToken } = store.getState().auth;
      if (!refreshToken) {
        store.dispatch({ type: LOGOUT });
        window.location = '/login';
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Token ${token}`;
          return axios(originalRequest);
        });
      }

      isRefreshing = true;

      try {
        const res = await axios.post(
            `${getBaseURL()}/auth/token/refresh/`,
            { refresh: refreshToken }
          );
        store.dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            accessToken: res.data.access,
            isVerifiedUser: true,
          },
        });

        processQueue(null, res.data.access);
        originalRequest.headers.Authorization = `Token ${res.data.access}`;
        return axios(originalRequest);
      } catch (err) {
        processQueue(err, null);
        store.dispatch({ type: LOGOUT });
        window.location = '/login';
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    if (status === 403) {
      store.dispatch(showAlert('danger', 'Error', 'Permission Denied'));
    }
    return Promise.reject(error);
  }
);


class API {
    constructor() {
    this.baseURL = getApiBaseUrl();
    }

    async putRequest(endpoint, data = {}) {
        return await axios.put(`${this.baseURL}${endpoint}`, data);
    }

    async patchRequest(endpoint, data = {}) {
        return await axios.patch(`${this.baseURL}${endpoint}`, data);
    }

    async postRequest(endpoint, data = {}) {
        return await axios.post(`${this.baseURL}${endpoint}`, data);
    }

    async deleteRequest(endpoint) {
        return await axios.delete(`${this.baseURL}${endpoint}`);
    }

    async postWithImageRequest(endpoint, data = {}, config = {}) {
        const defaultConfig = { headers: { 'Content-Type': 'multipart/form-data' } };
        return await axios.post(`${this.baseURL}${endpoint}`, data, { ...defaultConfig, ...config });
    }

    async getRequest(endpoint, headers) {
        return await axios.get(`${this.baseURL}${endpoint}`, headers);
    }
}

export default new API();
